import React from "react";
import LoginForm from "../Components/LoginForm";

export default function Login() {
  return (
    <div className="auth-page">
      <LoginForm />
    </div>
  );
}
